import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const plans = [
  { name: 'Light', monthly: 97, commission: 0.20 },
  { name: 'Plus', monthly: 147, commission: 0.20 },
  { name: 'Premium', monthly: 197, commission: 0.20 }
];

const referralCounts = [1, 10, 100];

function formatCurrency(value: number): string {
  return `R$ ${value.toFixed(2).replace('.', ',')}`;
}

export function ReferralSimulator() {
  useLanguage();
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl lg:text-2xl font-bold text-foreground">
          {translateInterfaceText("Simulação de Ganhos")}</h3>
        <p className="text-muted-foreground">
          {translateInterfaceText("Veja quanto você pode ganhar por mês")}</p>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-center">{translateInterfaceText("Comissão Recorrente Mensal (20%)")}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-3 px-4 font-semibold">{translateInterfaceText("Plano")}</th>
                  <th className="text-right py-3 px-4 font-semibold">{translateInterfaceText("Valor Mensal")}</th>
                  {referralCounts.map(count => (
                    <th key={count} className="text-right py-3 px-4 font-semibold">
                      {count} {count === 1 ? translateInterfaceText("Indicação") : translateInterfaceText("Indicações")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {plans.map((plan) => (
                  <tr key={plan.name} className="border-b">
                    <td className="py-3 px-4 font-medium">{plan.name}</td>
                    <td className="text-right py-3 px-4 text-muted-foreground">
                      {formatCurrency(plan.monthly)}
                    </td>
                    {referralCounts.map(count => {
                      const earnings = plan.monthly * plan.commission * count;
                      return (
                        <td 
                          key={count} 
                          className="text-right py-3 px-4 font-semibold text-primary"
                        >
                          {formatCurrency(earnings)}{translateInterfaceText("/mês")}</td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="mt-6 p-4 bg-muted rounded-lg text-center">
            <p className="text-sm text-muted-foreground">
              💡 <span className="font-semibold">{translateInterfaceText("Exemplo:")}</span> {" "}{translateInterfaceText("Com 100 indicações no plano Premium, você ganha")}{" "}<span className="font-bold text-primary">{formatCurrency(197 * 0.20 * 100)}</span> {" "}{translateInterfaceText("todo mês!")}</p>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
